import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader, Quote, Container, Content, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Header from '../../components/Header.js';
import * as notifier from '../../actions/notifier.js';

import {
    savePlanDesignBenefitInitData, savePlanDesignField, getPlanDesignRevisions, getSinglePlanDesignRevision,
    savePlanDesign, saveModularBlueprint, saveModularBenefitInitData, saveModularField, addClass, editClass,
    addDivision, editDivision, uploadAccountHistory, submitCommissions, saveCommissions, getCommissions,
    getMasterApplicationData, updateMasterApp, completeMasterApp, submitPricing, savePricingInput, savePricing,
    saveTelusDrugPlanID, getPricingRevisions, getSinglePricingRevision, sendMasterAppLink, getAccountHistoryKeys,
    submitPlanDesigns, submitModuleBlueprint, createPlanDesign, revertToRevision, clonePlanDesign,
    assignPlans, rejectPricing, createPlanDesignFromUpload, getSpecialityProductRates, saveSpecialityProductRates,
    submitSpecialityProductRates
} from '../../actions/accounts.js';

import {
    getQuote, savePlanType, savePricingCoverages, sendReviewRequest, convertQuote, setState,
    removeClass, removeDivision, editQuote, updateCommissionSplitsForQuote
} from '../../actions/quotes.js';

import { getPdf } from '../../actions/master.js';
import { validateBankingDetails, getAdvisor, searchAdvisors } from '../../actions/advisors.js';
import config from '../../config.js';
import * as session from '../../services/session.js';
import permissionLevel from '../../services/permissions.js';

class QuoteContainer extends PureComponent {
    state = {
        selectedSection: null,
        breadcrumbs: [],
        subHeader: '',
        isAdvisorView: Boolean(this.props.match.params.advisorID)
    };

    async componentDidMount() {
        const quoteMeta = await this.props.dispatch(getQuote(this.props.match.params.quoteID));

        if (!this.props.advisors.currentAdvisor) {
            this.props.dispatch(getAdvisor(quoteMeta.advisor.advisorID));
        }
    }

    _searchAdvisors = (query) => this.props.dispatch(searchAdvisors(query));

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Quotes', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    _setSelectedSection = (section) => {
        this.setState({
            selectedSection: section
        });
    };

    _downloadAccountHistory = async (quoteID) => {
        const keys = await this.props.dispatch(getAccountHistoryKeys(null, quoteID));

        keys.map((key) => {
            const url = `${ config.apiRequestUrl }/accounts/${ null }/history/file/${ key.type }/${ key.filename }/${ quoteID }`;
            window.open(encodeURI(url));
            return true;
        });
    };

    _downloadCarrierPackage = async () => {
        const token = await session.getToken();
        const url = `${ config.apiRequestUrl }/accounts/${ null }/carrierPackage/${ this.props.quote.quoteID }/${ token }`;
        window.open(encodeURI(url));
        return true;
    };

    _buildBreadcrumbs = () => {
        if (this.state.isAdvisorView) {
            if (this.state.selectedSection) {
                return [
                    {
                        title: 'Advisors',
                        link: `/advisors`
                    },
                    {
                        title: `${ this.props.quote.meta.advisor.firstname } ${ this.props.quote.meta.advisor.lastname }`,
                        link: `/advisors/${ this.props.match.params.advisorID }`
                    },
                    {
                        title: 'Quotes',
                        link: `/advisors/${ this.props.match.params.advisorID }?stage=advisor-quotes`
                    },
                    {
                        title: this.props.quote.meta.company,
                        onClick: () => this._setSelectedSection(null)
                    }
                ];
            }

            return [
                {
                    title: 'Advisors',
                    link: `/advisors`
                },
                {
                    title: `${ this.props.quote.meta.advisor.firstname } ${ this.props.quote.meta.advisor.lastname }`,
                    link: `/advisors/${ this.props.match.params.advisorID }`
                },
                {
                    title: 'Quotes',
                    link: `/advisors/${ this.props.match.params.advisorID }?stage=advisor-quotes`
                }
            ];
        }

        if (this.state.selectedSection) {
            return [
                {
                    title: 'Quotes For Review',
                    link: `/quotes-for-review`
                },
                {
                    title: this.props.quote.meta.company,
                    onClick: () => this._setSelectedSection(null)
                }
            ];
        }

        return [
            {
                title: 'Quotes For Review',
                link: `/quotes-for-review`
            }
        ];
    };

    _getSubHeader = () => {
        let subHeader = null;

        if (this.state.selectedSection === 'plan-design') {
            subHeader = 'Plan Design';
        } else if (this.state.selectedSection === 'classes-divisions') {
            subHeader = 'Classes & Divisions';
        } else if (this.state.selectedSection === 'settings') {
            subHeader = 'Settings';
        } else if (this.state.selectedSection === 'administrators') {
            subHeader = 'Administrators';
        } else if (this.state.selectedSection === 'account-history') {
            subHeader = 'Account History';
        } else if (this.state.selectedSection === 'master-application') {
            subHeader = 'Master Application';
        } else if (this.state.selectedSection === 'assign-plans') {
            subHeader = 'Plan Assign';
        } else if (this.state.selectedSection === 'commissions') {
            subHeader = 'Commissions';
        } else if (this.state.selectedSection === 'pricing' || this.state.selectedSection === 'speciality-product-rates') {
            subHeader = 'Pricing';
        } else if (this.state.selectedSection === 'request-approval') {
            subHeader = i18n.t(tokens.titles.requestApproval);
        } else {
            subHeader = this.props.quote.meta.company;
        }

        return subHeader;
    };

    render() {
        const { quote, currentAdvisor, accessType } = this.props;

        if (!quote || !currentAdvisor) {
            return <Loader isContainer/>;
        }

        const subHeader = this._getSubHeader();
        const breadcrumbs = this._buildBreadcrumbs();
        const advisorID = quote.meta.advisor.advisorID;
        const hasCommissionSplitWritePermissions = permissionLevel('Plan Pricing', accessType).includes('write');

        return (
            <Container>
                <Header
                    subHeader={ subHeader }
                    breadcrumbs={ breadcrumbs }
                    selectedTitle="quotes"
                />

                <Content>
                    <Quote
                        loader={ this.props.loader }
                        selectedSection={ this.state.selectedSection }
                        setSelectedSection={ this._setSelectedSection }
                        permissionLevel={ (type) => permissionLevel(type, this.props.accessType) }
                        agents={ this.props.agents }
                        quote={ quote }
                        currentAccountMeta={ quote.meta }
                        isMasterSite={ true }
                        whitelabel={{}}
                        advisorMeta={ quote.meta.advisor }
                        searchAdvisors={this._searchAdvisors}
                        setState={ (...params) => this.props.dispatch(setState(...params, quote.quoteID)) }
                        displayError={ (...params) => this.props.dispatch(notifier.displayError(...params)) }

                        specialityProductMetaConfigs={ currentAdvisor.specialityProductMetaConfigs }
                        getSpecialityProductRates={ () => this.props.dispatch(getSpecialityProductRates(null, advisorID, quote.quoteID))}
                        saveSpecialityProductRates={ (...params) => this.props.dispatch(saveSpecialityProductRates(null, quote.quoteID, ...params))}
                        submitSpecialityProductRates={ (...params) => this.props.dispatch(submitSpecialityProductRates(null, advisorID, quote.quoteID, ...params))}

                        editQuote={ (...params) => this.props.dispatch(editQuote(quote.quoteID, ...params)) }

                        // classes and divisions handler
                        addClass={ (...params) => this.props.dispatch(addClass(...params, quote.quoteID)) }
                        editClass={ (...params) => this.props.dispatch(editClass(...params, quote.quoteID)) }
                        removeClass={ (...params) => this.props.dispatch(removeClass(...params, quote.quoteID)) }
                        addDivision={ (...params) => this.props.dispatch(addDivision(...params, quote.quoteID)) }
                        editDivision={ (...params) => this.props.dispatch(editDivision(...params, quote.quoteID)) }
                        removeDivision={ (...params) => this.props.dispatch(removeDivision(...params, quote.quoteID)) }
                        validateBankingDetails={ (...params) => this.props.dispatch(validateBankingDetails(...params)) }
                        bankingDetailsVerifying={ this.props.bankingDetailsVerifying }

                        // account history handler
                        uploadAccountHistory={ (...params) => this.props.dispatch(uploadAccountHistory(...params, quote.quoteID)) }
                        downloadAccountHistory={ () => this._downloadAccountHistory(quote.quoteID) }
                        downloadCarrierPackage={ () => this._downloadCarrierPackage() }

                        // plan design routes
                        savePlanType={ (...params) => this.props.dispatch(savePlanType(...params, quote.quoteID)) }
                        createPlanDesign={ (...params) => this.props.dispatch(createPlanDesign(...params, quote.quoteID)) }
                        createPlanDesignFromUpload={ (...params) => this.props.dispatch(createPlanDesignFromUpload(...params, quote.quoteID)) }
                        savePlanDesign={ (...params) => this.props.dispatch(savePlanDesign(...params, quote.quoteID)) }
                        clonePlanDesign={ (...params) => this.props.dispatch(clonePlanDesign(...params, quote.quoteID)) }
                        savePlanDesignBenefitInitData={ (...params) => this.props.dispatch(savePlanDesignBenefitInitData(...params, quote.quoteID)) }
                        savePlanDesignField={ (...params) => this.props.dispatch(savePlanDesignField(...params, quote.quoteID)) }
                        getPlanDesignRevisions={ (...params) => this.props.dispatch(getPlanDesignRevisions(...params, quote.quoteID)) }
                        getSinglePlanDesignRevision={ (...params) => this.props.dispatch(getSinglePlanDesignRevision(...params, quote.quoteID)) }
                        revertToRevision={ (...params) => this.props.dispatch(revertToRevision(...params, quote.quoteID)) }
                        saveModularBenefitInitData={ (...params) => this.props.dispatch(saveModularBenefitInitData(...params, quote.quoteID)) }
                        saveModularField={ (...params) => this.props.dispatch(saveModularField(...params, quote.quoteID)) }
                        saveModularBlueprint={ (...params) => this.props.dispatch(saveModularBlueprint(...params, quote.quoteID)) }
                        submitPlanDesigns={ (...params) => this.props.dispatch(submitPlanDesigns(...params, quote.quoteID)) }
                        submitModuleBlueprint={ (...params) => this.props.dispatch(submitModuleBlueprint(...params, quote.quoteID)) }
                        downloadPlanDesignForPrivateLabel={ (...params) => this.props.dispatch(getPdf(...params)) }

                        // commissions
                        submitCommissions={ (...params) => this.props.dispatch(submitCommissions(...params, quote.quoteID)) }
                        saveCommissions={ (...params) => this.props.dispatch(saveCommissions(...params, quote.quoteID)) }
                        getCommissions={ (...params) => this.props.dispatch(getCommissions(...params, quote.quoteID)) }
                        updateCommissionSplitsForQuote={ (...params) => this.props.dispatch(updateCommissionSplitsForQuote(...params, quote.quoteID)) }
                        hasCommissionSplitWritePermissions={hasCommissionSplitWritePermissions}

                        // // master application
                        getMasterApplicationData={ (...params) => this.props.dispatch(getMasterApplicationData(...params, quote.quoteID)) }
                        updateMasterApp={ (...params) => this.props.dispatch(updateMasterApp(...params, quote.quoteID)) }
                        completeMasterApp={ (...params) => this.props.dispatch(completeMasterApp(...params, quote.quoteID)) }

                        // send for underwriting
                        sendReviewRequest={ () => this.props.dispatch(sendReviewRequest(quote.quoteID)) }

                        // pricing
                        submitPricing={ (...params) => this.props.dispatch(submitPricing(...params, quote.quoteID)) }
                        savePricingInput={ (...params) => this.props.dispatch(savePricingInput(...params, quote.quoteID)) }
                        savePricing={ (...params) => this.props.dispatch(savePricing(...params, quote.quoteID)) }
                        saveTelusDrugPlanID={ (...params) => this.props.dispatch(saveTelusDrugPlanID(...params, quote.quoteID)) }
                        getPricingRevisions={ (...params) => this.props.dispatch(getPricingRevisions(...params, quote.quoteID)) }
                        getSinglePricingRevision={ (...params) => this.props.dispatch(getSinglePricingRevision(...params, quote.quoteID)) }
                        saveCoverages={ (...params) => this.props.dispatch(savePricingCoverages(...params, quote.quoteID)) }

                        // assign plans
                        assignPlans={ (...params) => this.props.dispatch(assignPlans(...params, quote.quoteID)) }
                        rejectPricing={ (...params) => this.props.dispatch(rejectPricing(...params, quote.quoteID)) }

                        // finish setup -> send review to signing auth
                        sendMasterAppLink={ (...params) => this.props.dispatch(sendMasterAppLink(...params, quote.quoteID)) }

                        convertQuote={ (...params) => this.props.dispatch(convertQuote(...params, quote.quoteID)) }

                        downloadSpecialityProductRatesPdf={ (...params) => this.props.dispatch(getPdf(...params))}
                    />
                </Content>

                <span id="quote-single" />
            </Container>
        );
    }
}

QuoteContainer.propTypes = {
    quote: PropTypes.object
};

/**
 * @param state
 * @returns {{quote: null, loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    bankingDetailsVerifying: state.advisors.bankingDetailsVerifying,
    quote: state.quotes.currentQuote,
    accessType: state.master.access,
    agents: state.master.agents,
    currentAdvisor: state.advisors.currentAdvisor,
    advisors: state.advisors
});

export default connect(mapStateToProps)(QuoteContainer);